// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
}

.card-container {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
}

.card {
    width: 9cm;
    height: 6cm;

     /* according to printer        */
    /* width: 12cm;
    height: 7.4cm; */

    display: flex;
    flex-direction: column;
    position: relative;
    border: 1px solid #ccc;
    border-radius: 10px;
    overflow: hidden;
}

.card-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    flex: 0 0 70px;
    display: flex;
    align-items: center;
    padding: 8px;
    background-color: #f0f0f0;
}

.card-body {
    flex: 1 1;
    display: flex;
    align-items: center;
    padding: 8px;
    margin-top: 80px;
    margin-bottom: 40px;
}

.user-image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 2px solid #4a4a4a;
    margin-right: 20px;
}

.user-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 3px;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
}

@media (max-width: 768px) {
    .user-details {
        font-size: 3vw;
    }
}

@media (max-width: 480px) {
    .user-details {
        font-size: 4vw;
    }
}

.barcode {
    margin-left: 90px;
    margin-top: 5px;
    width: 100%;
    max-width: 30%;
    height: auto;
    /* flex-shrink: 0; */
    text-align: center;
}

.card-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px;
}

.logo {
    width: 2.5rem;
    height: 4rem;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 0.5rem;
}

.text-small {
    font-size: 0.45rem;
}

.text-xs {
    font-size: 0.50rem;
}

.text-sm {
    font-size: 0.85rem;
}

.font-bold {
    font-weight: bold;
}

`, "",{"version":3,"sources":["webpack://./src/styles/IDCard.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;;KAEV,gCAAgC;IACjC;oBACgB;;IAEhB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n}\n\n.card-container {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n}\n\n.card {\n    width: 9cm;\n    height: 6cm;\n\n     /* according to printer        */\n    /* width: 12cm;\n    height: 7.4cm; */\n\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.card-header {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    flex: 0 0 70px;\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    background-color: #f0f0f0;\n}\n\n.card-body {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    margin-top: 80px;\n    margin-bottom: 40px;\n}\n\n.user-image {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    border: 2px solid #4a4a4a;\n    margin-right: 20px;\n}\n\n.user-details {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-left: 3px;\n    font-size: 1rem;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n@media (max-width: 768px) {\n    .user-details {\n        font-size: 3vw;\n    }\n}\n\n@media (max-width: 480px) {\n    .user-details {\n        font-size: 4vw;\n    }\n}\n\n.barcode {\n    margin-left: 90px;\n    margin-top: 5px;\n    width: 100%;\n    max-width: 30%;\n    height: auto;\n    /* flex-shrink: 0; */\n    text-align: center;\n}\n\n.card-footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 4px;\n}\n\n.logo {\n    width: 2.5rem;\n    height: 4rem;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-right: 0.5rem;\n}\n\n.text-small {\n    font-size: 0.45rem;\n}\n\n.text-xs {\n    font-size: 0.50rem;\n}\n\n.text-sm {\n    font-size: 0.85rem;\n}\n\n.font-bold {\n    font-weight: bold;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
